import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["digestToggle", "digestOptions", "digestCount", "timeInput1", "timeInput2", "timeInput3", "timeInput4"]

  connect() {
    this.updateTimeInputs()
  }

  toggleDigestOptions() {
    const isEnabled = this.digestToggleTarget.checked
    if (isEnabled) {
      this.digestOptionsTarget.classList.remove("hidden")
    } else {
      this.digestOptionsTarget.classList.add("hidden")
    }
  }

  updateTimeInputs() {
    const count = parseInt(this.digestCountTarget.value) || 2

    for (let i = 1; i <= 4; i++) {
      const target = this[`timeInput${i}Target`]
      if (target) {
        if (i <= count) {
          target.classList.remove("hidden")
        } else {
          target.classList.add("hidden")
        }
      }
    }
  }
}
